export default __webpack_public_path__ + "static/media/grafema_f1rst_09.d1666571.jpg";